









import { defineComponent, PropType } from "@vue/composition-api";
import BaseButton from "@/components/BaseButton";
import BaseIcon from "@/components/BaseIcon";

export default defineComponent({
  name: "SwitchMicrophone",
  components: { BaseIcon, BaseButton },
  props: {
    audioConstraints: { type: [Object, Boolean] as PropType<MediaTrackConstraints | boolean> },
  },
  setup(props, { emit }) {
    const onClick = () => {
      emit("changeDevice", { audio: !props.audioConstraints });
    };
    return {
      onClick,
    };
  },
});
